<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>

    <v-alert
      :value="true"
      v-if="infoMessages"
      id="infoAlert"
      border="top"
      dismissible
      color="#2A3B4D"
      dark
    >
      <div v-for="(infoMessage, k) in infoMessages" v-bind:key="infoMessage.id">
        <div class="text-h6">
          {{ infoMessage.title }}
        </div>
        <div v-html="infoMessage.message"></div>
        <hr
          v-if="k < infoMessages.length - 1"
          style="margin: 10px 0px 10px 0px"
        />
      </div>
    </v-alert>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
const defaultLayout = "no-sidebar";
export default {
  computed: {
    ...mapState("app", ["config"]),
    infoMessages() {
      if (this.config.maintenance) {
        let ret = this.config.maintenance.filter((el) => {
          return el.allowLogin;
        });

        if (
          this.config.maintenance.filter((el) => {
            return !el.allowLogin;
          }).length &&
          this.$route.name != "login"
        ) {
          this.logout();
        }

        return ret.length ? ret : false;
      }
      return false;
    },
    layout() {
      return (this.$route.meta.layout || defaultLayout) + "-layout";
    },
  },
  created() {
    this.getConfig();

    setInterval(() => {
      this.getConfig();
    }, 1000 * 30);
  },
  updated() {},
  methods: {
    ...mapActions("app", ["getConfig"]),
    ...mapActions("user", ["logout"]),
  },
};
</script>

<style>
#infoAlert {
  text-align: center;
  position: fixed !important;
  min-width: 400px;
  max-width: 550px;
  text-align: left;
  right: 10px;
  bottom: 70px;
  width: 500px;
}
</style>

